import { quotesPermissionAliases } from './quotesPermissionAliases';

const userPermissions = window.Laravel.jsPermissions.permissions;
const userRoles = window.Laravel.jsPermissions.roles;

/**
 * Debe coincidir con config/permissions.php → section_parents
 */
const SECTION_PARENTS = {
    'sia.portal': 'sia.portal.',
    'sia.manage': 'sia.manage.',
};

/** Retrocompatibilidad — config/sia_permissions.php → legacy */
const SIA_LEGACY = {
    'sia.portal.capacitacion': 'sia.portal.',
    'sia.manage': 'sia.manage.',
    'sia.access': ['sia.portal.atencion-cliente.view'],
};

const permissionList = Array.isArray(userPermissions)
    ? userPermissions
    : Object.values(userPermissions || {});

export const hasExactPermission = (permission) =>
    permissionList.some((item) => permission === item);

const hasLegacySiaPermission = (permission) => {
    for (const [legacy, rule] of Object.entries(SIA_LEGACY)) {
        if (!hasExactPermission(legacy)) {
            continue;
        }
        if (typeof rule === 'string' && permission.startsWith(rule)) {
            return true;
        }
        if (Array.isArray(rule) && rule.includes(permission)) {
            return true;
        }
    }

    return false;
};

const hasSectionParent = (permission) =>
    Object.entries(SECTION_PARENTS).some(
        ([parent, prefix]) =>
            permission.startsWith(prefix) && hasExactPermission(parent),
    );

const hasQuotesViaAlias = (permission) =>
    quotesPermissionAliases(permission).some((alias) => hasExactPermission(alias));

export const hasPermission = (permission) => {
    if (userRoles.some((item) => 'Admin' === item)) {
        return true;
    }

    return hasExactPermission(permission)
        || hasSectionParent(permission)
        || hasLegacySiaPermission(permission)
        || hasQuotesViaAlias(permission);
};

export const hasRole = (roleName) => {
    return userRoles.some((item) => item === roleName);
};
